export default "__VITE_ASSET__b1dbc5a4__"